module.exports = __webpack_public_path__ + "img/logo.802b6544.png";